import Axios from 'axios';

export const getConfigLayout = () => Axios.get('configLayout');
